import { Skeleton, Spin } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiSubscriptionPlanDetails } from '../../../api/subscription';
import logoDLPAY from '../../../assets/images/logo.png';
import { formatPrice } from '../../../utils/format';
import { frequencyNoun } from '../../../utils/subscriptions';
import PublicStatusPage from '../../common/PublicStatusPage/PublicStatusPage';
import SubscriptionCheckoutForm from '../../common/SubscriptionCheckoutForm/SubscriptionCheckoutForm';
import './ExternalSubscription.scss';

const ExternalSubscription = () => {
  const { slug } = useParams();
  const [planInfo, setPlanInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPlan = useCallback(() => {
    setLoading(true);
    setError(null);
    apiSubscriptionPlanDetails(slug)
      .then((data) => {
        setPlanInfo(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setError(err);
      });
  }, [slug]);

  useEffect(() => {
    fetchPlan();
  }, [fetchPlan]);

  if (error) {
    return error?.status === 404 ? (
      <PublicStatusPage
        className="ExternalSubscription"
        title="Assine seu plano"
        merchantName={planInfo?.seller_name}
        variant="neutral"
        heading="Não encontramos este plano"
        body="O link pode estar incompleto ou o plano pode não estar mais disponível para novas assinaturas. Confira o endereço no e-mail ou na mensagem que você recebeu."
        action={null}
      />
    ) : (
      <PublicStatusPage
        className="ExternalSubscription"
        title="Assine seu plano"
        merchantName={planInfo?.seller_name}
        variant="warning"
        heading="Não conseguimos carregar este plano"
        body="Isso costuma ser temporário."
        action={{ label: 'Tentar novamente', onClick: fetchPlan }}
      />
    );
  }

  return (
    <section className='ExternalSubscription'>
      <header>
        <div className="container-header">
          <div className="navigation">
            <p>{planInfo?.seller_name}</p>
            <img src={logoDLPAY} alt="Logo DLPay Private" />
          </div>
          <h2>Assine seu plano</h2>
        </div>
      </header>
      <div className="content">
        <div className="details-content">
          <div className="info-details">
            {loading ? (
              <Skeleton active />
            ) : (
              <>
                <span>{planInfo?.name}</span>
                <p className="price">
                  {formatPrice(planInfo?.amount)}
                  <small className="interval">/{frequencyNoun(planInfo?.frequency)}</small>
                </p>
                <strong>Descrição:</strong>
                <p>{planInfo?.description}</p>
              </>
            )}
          </div>
          {loading && <Skeleton paragraph={{ rows: 1 }} active />}
        </div>
        <div className="forms-container">
          <div className="container-checkout">
            {!loading && <SubscriptionCheckoutForm planInfo={planInfo} />}
            {loading && <Spin style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExternalSubscription;
